import React, { useEffect, useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import './HistoricalEventList.css';
import config from '../../services/apiConfig';
import { apiPaths } from '../../services/apiPath';
import moment from 'moment';

const HistoricalEventList = ({ vendorId, weekNumber, startDate, endDate, onSelectionChange }) => {
  const [events, setEvents] = useState([]);
  const [selected, setSelected] = useState({});
  const [showDetails, setShowDetails] = useState({}); // control toggle for each card

  useEffect(() => {
    const fetchHistoricalEvents = async () => {
      try {
        const response = await fetch(config.BASE_URI + apiPaths.adminData, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            payload: {
              body: {
                query_type: 'fetch_previous_week_period_data',
                vendor: vendorId,
                start_date: startDate,
                end_date: endDate,
              }
            }
          })
        });

        const data = await response.json();
        if (data.success && Array.isArray(data.data)) {
          const init = {};
          data.data.forEach((e) => {
            init[e.event_id] = { include: true, excludeBulkApply: false };
          });

          setSelected(init);
          setEvents(data.data);
          const included = data.data.filter(e => init[e.event_id].include);
          onSelectionChange(included);
        } else {
          console.warn("⚠️ No valid historical data returned.");
        }
      } catch (error) {
        console.error("❌ Failed to fetch historical event data:", error);
      }
    };

    fetchHistoricalEvents();
  }, [vendorId, weekNumber, startDate, endDate]);

  const toggleInclude = (eventId) => {
    const updated = {
      ...selected,
      [eventId]: {
        ...selected[eventId],
        include: !selected[eventId]?.include,
      },
    };
    setSelected(updated);
    const filtered = events.filter((e) => updated[e.event_id]?.include);
    onSelectionChange(filtered);
  };

  const toggleExcludeBulkApply = (eventId) => {
    const updated = {
      ...selected,
      [eventId]: {
        ...selected[eventId],
        excludeBulkApply: !selected[eventId]?.excludeBulkApply,
      },
    };
    setSelected(updated);
  };

  const toggleDetails = (eventId) => {
    setShowDetails((prev) => ({
      ...prev,
      [eventId]: !prev[eventId]
    }));
  };

  return (
    <div className="mt-4">
      <h5 className="fw-bold text-secondary">  Events By The Outlet Last Year - Week {weekNumber}</h5>
      {events.map((event) => {
        const profitPercent = event.total_sales > 0
          ? ((event.profit_estimate_after_payout_stock_and_labor / event.total_sales) * 100).toFixed(1)
          : '0.0';

        const stockPercent = event.total_sales > 0
          ? ((event.total_stock_cost_in_dollars / event.total_sales) * 100).toFixed(1)
          : '0.0';

        const wagePercent = event.total_sales > 0
          ? ((event.total_wage_cost_for_this_event / event.total_sales) * 100).toFixed(1)
          : '0.0';

        return (
          <Card className="mb-3 shadow-sm border-light" key={event.event_id}>
            <Card.Body>
              <Card.Title>{event.event_name}</Card.Title>
              <Card.Text className="mb-2">
                <strong>Location:</strong> {event.location} <br />
                <strong>Total Sales:</strong> ${event.total_sales?.toFixed(2)} <br />
                <strong>Profit %:</strong>{' '}
                <span style={{ color: profitPercent >= 0 ? 'green' : 'red' }}>{profitPercent}%</span> <br />
                <strong>Stock Cost:</strong> {stockPercent}% of sales{' '}
                {showDetails[event.event_id] && (
                  <> (${event.total_stock_cost_in_dollars?.toFixed(2)})</>
                )}
                <br />
                <strong>Wage Cost:</strong> {wagePercent}% of sales{' '}
                {showDetails[event.event_id] && (
                  <> (${event.total_wage_cost_for_this_event?.toFixed(2)})</>
                )}
                <br />
                {showDetails[event.event_id] && (
                  <>
                    <strong>Payout:</strong> ${event.payout?.toFixed(2)} <br />
                    <strong>Estimated Profit:</strong> ${event.profit_estimate_after_payout_stock_and_labor?.toFixed(2)} <br />
                  </>
                )}
              </Card.Text>

              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => toggleDetails(event.event_id)}
                className="mb-2"
              >
                {showDetails[event.event_id] ? 'Hide $ Details' : 'Show $ Details'}
              </Button>

              <Form.Check
                type="checkbox"
                checked={selected[event.event_id]?.include || false}
                onChange={() => toggleInclude(event.event_id)}
                label="Include in schedule"
                className="mt-2"
              />

              <Form.Check
                type="checkbox"
                checked={selected[event.event_id]?.excludeBulkApply || false}
                onChange={() => toggleExcludeBulkApply(event.event_id)}
                label="Exclude from bulk apply"
                className="mt-1 text-danger"
              />
            </Card.Body>
          </Card>
        );
      })}
    </div>
  );
};

export default HistoricalEventList;
